module.exports = __webpack_public_path__ + "img/close2.5173eae4.png";